import axios from '../../axios'
import { takeLatest, call, put } from 'redux-saga/effects'
import { createAction, Action } from 'redux-actions'

// Saga action strings
export const FETCH_LEGAL_DOCS = 'saga/LegalDocs/FETCH_LEGAL_DOCS'
export const FETCH_LEGAL_DOCS_SUCCESS =
  'saga/LegalDocs/FETCH_LEGAL_DOCS_SUCCESS'
export const FETCH_LEGAL_DOCS_FAILURE =
  'saga/LegalDocs/FETCH_LEGAL_DOCS_FAILURE'

export const actions = {
  FETCH_LEGAL_DOCS,
  FETCH_LEGAL_DOCS_FAILURE,
  FETCH_LEGAL_DOCS_SUCCESS
}

type LegalDocsSagaActionCreators = {
  fetchLegalDocs: () => Action<any>,
  fetchLegalDocsSuccess: number => Action<any>,
  fetchLegalDocsFailure: object => Action<any>
}

export const actionCreators: LegalDocsSagaActionCreators = {
  fetchLegalDocs: createAction(FETCH_LEGAL_DOCS),
  fetchLegalDocsSuccess: createAction(FETCH_LEGAL_DOCS_SUCCESS),
  fetchLegalDocsFailure: createAction(FETCH_LEGAL_DOCS_FAILURE)
}

export default function * watchLegalDocs () {
  yield takeLatest(FETCH_LEGAL_DOCS, getLegalDocs)
}

export function * getLegalDocs (action) {
  try {
    const repoInfo = yield call(axios.get, 'legal/docs/latest')
    yield put(actionCreators.fetchLegalDocsSuccess(repoInfo.data))
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      yield put(
        actionCreators.fetchLegalDocsFailure(error.response.data.errors[0])
      )
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      yield put(actionCreators.fetchLegalDocsFailure(error.request))
    } else {
      // Something happened in setting up the request that triggered an Error
      yield put(actionCreators.fetchLegalDocsFailure(error.message))
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/legalDocs/legalDocsSaga.js